import React, { useState } from 'react';
import { Col, DatePicker, Form, Row } from 'antd';
import CollapseCommon from 'components/common/Collapse/CollapseCommon';
import LabelWithRequired from 'components/common/Label/LabelWithRequired';
import { InputCommon } from 'components/common/Input/InputCommon';
import SelectCommon from 'components/common/Select/SelectCommon';
import { emailRules, phoneNumber, timeCreate, userName, wareHome } from 'utils/formRules';
import BarcodeCommon from 'components/common/Barcode/BarcodeCommon';
import { CalendarBlank, Plus } from '@phosphor-icons/react';
import { useGetAllWarehousesQuery, useGetStaffsQuery, useGetSuppliersQuery } from 'services';
import { SupplierOrderInforProps } from 'types';
import QuickAddSupplierModal from 'components/common/Modal/QuickAddSupplierModal';

const SupplierOrderInfor: React.FC<SupplierOrderInforProps> = ({
  form,
  handleBarcode,
  isPurchase = false,
  setSelectedSupplierId,
}) => {
  const [showQuickAddSupplier, setShowQuickAddSupplier] = useState(false);
  const { data: suppliers, refetch: refetchSuppliers } = useGetSuppliersQuery({
    query: {
      include: 'baseUser',
    },
  });
  const { data: staff } = useGetStaffsQuery({
    query: {
      include: 'baseUser',
    },
  });
  const { data: warehouseResponse } = useGetAllWarehousesQuery({
    query: {
      size: 'unlimited',
    },
  });
  return (
    <div className='flex flex-col gap-6 h-full'>
      <CollapseCommon
        title={!isPurchase ? 'THÔNG TIN ĐƠN ĐẶT HÀNG' : 'THÔNG TIN PHIẾU NHẬP HÀNG'}
        collapseKey='info'
        hideExpandIcon
        disableCollapse
        size='md'
        className='!my-0 h-full'
      >
        <Form form={form} layout='vertical'>
          <Row gutter={[24, 12]}>
            <Col xl={8} xs={isPurchase ? 12 : 24}>
              <Form.Item label={<LabelWithRequired label='Mã nhập hàng' />} name='code' className='mb-0'>
                <InputCommon type='text' placeholder='Nhập vào mã...' className='!px-3 text-sm' />
              </Form.Item>
            </Col>
            <Col xl={8} xs={isPurchase ? 12 : 24}>
              <Form.Item
                label={<LabelWithRequired label='Nhà cung cấp' />}
                required={false}
                name='supplierId'
                className='mb-0'
                rules={[{ required: true, message: 'Vui lòng chọn nhà cung cấp!' }]}
              >
                <div className='flex gap-2 items-end'>
                  <div className='flex-1'>
                    <SelectCommon
                      placeholderSelect='Chọn nhà cung cấp'
                      options={suppliers?.data?.rows?.map((supplier) => ({
                        label: supplier?.baseUser?.name ?? '',
                        value: supplier?.id,
                      }))}
                      onChange={(value) => setSelectedSupplierId && setSelectedSupplierId(value)}
                      selectType='filterSelect'
                    />
                  </div>
                  <button
                    onClick={() => setShowQuickAddSupplier(true)}
                    className='px-3 py-1.5 bg-[var(--primaryColor500)] text-white rounded hover:bg-[var(--primaryColor600)] transition flex items-center gap-2 whitespace-nowrap text-sm h-10'
                    title='Thêm nhà cung cấp nhanh'
                    type='button'
                  >
                    <Plus size={18} weight='bold' />
                  </button>
                </div>
              </Form.Item>
            </Col>
            <Col xl={8} xs={isPurchase ? 12 : 24}>
              <Form.Item shouldUpdate className='mb-0'>
                {() => (
                  <Form.Item label={<LabelWithRequired label='Barcode' />} name='barcode' className='mb-0'>
                    <BarcodeCommon
                      displayGenerate={false}
                      valueBarcode={form.getFieldValue('barcode')}
                      onGenerate={handleBarcode}
                    />
                  </Form.Item>
                )}
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label='Mô tả đơn hàng' required={false} name='describeOrder' className='mb-0 '>
                <InputCommon type='textarea' placeholder='Nhập mô tả đơn hàng...' className='text-sm' />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </CollapseCommon>
      <CollapseCommon
        title='THÔNG TIN NGƯỜI NHẬN'
        collapseKey='info'
        hideExpandIcon
        disableCollapse
        size='md'
        className='!my-0  min-h-[437px]'
      >
        <Form form={form} layout='vertical'>
          <Row gutter={[24, 12]}>
            <Col xl={8} xs={isPurchase ? 12 : 24}>
              <Form.Item
                label={<LabelWithRequired label='Họ và tên' />}
                rules={userName}
                required={false}
                name='userName'
                className='mb-0'
              >
                <SelectCommon
                  placeholderSelect='Chọn hoặc nhập vào họ tên'
                  options={staff?.data?.rows?.map((staff) => ({
                    label: staff?.baseUser?.name ?? '',
                    value: staff?.baseUser?.name ?? '',
                  }))}
                  selectType='filterSelect'
                  onChange={(value) => {
                    const selected = staff?.data?.rows?.find((sup) => sup.baseUser?.name === value);
                    if (selected) {
                      form.setFieldsValue({
                        phoneNumber: selected.baseUser?.phoneNumber || '',
                        email: selected.baseUser?.email || '',
                      });
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xl={8} xs={isPurchase ? 12 : 24}>
              <Form.Item
                label={<LabelWithRequired label='Số điện thoại' />}
                required={false}
                rules={phoneNumber}
                name='phoneNumber'
                className='mb-0'
              >
                <InputCommon type='text' placeholder='Nhập vào số điện thoại' className='!px-3 text-sm' />
              </Form.Item>
            </Col>
            <Col xl={8} xs={isPurchase ? 12 : 24}>
              <Form.Item
                label={<LabelWithRequired label='Email' />}
                required={false}
                rules={emailRules}
                name='email'
                className='mb-0 '
              >
                <InputCommon type='text' placeholder='Nhập vào Email' className='!px-3 text-sm' />
              </Form.Item>
            </Col>
            <Col xl={8} xs={isPurchase ? 12 : 24}>
              <Form.Item
                label={<LabelWithRequired label='Kho nhập' />}
                required={false}
                rules={wareHome}
                name='warehouse'
                className='mb-0'
              >
                <SelectCommon
                  placeholderSelect='Chọn kho nhập'
                  options={[
                    ...(warehouseResponse?.data?.rows || []).map((warehouse) => ({
                      label: warehouse.name,
                      value: warehouse.id,
                    })),
                  ]}
                  selectType='filterSelect'
                />
              </Form.Item>
            </Col>
            <Col xl={8} xs={isPurchase ? 12 : 24}>
              <Form.Item
                label={<LabelWithRequired label='Thời gian giao hàng' />}
                required={false}
                rules={timeCreate}
                name='deliveryDate'
                className='mb-0'
              >
                <DatePicker
                  className='w-full h-[30px] xl:h-[36px] 2xl:h-[40px]'
                  placeholder='Chọn ngày nhập hàng'
                  format='DD/MM/YYYY'
                  suffixIcon={<CalendarBlank className='text-[var(--textBlack100)]' />}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label='Ghi chú' required={false} name='describeNote' className='mb-0 '>
                <InputCommon type='textarea' placeholder='Nhập ghi chú...' className='text-sm' />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </CollapseCommon>
      <QuickAddSupplierModal
        isOpen={showQuickAddSupplier}
        onClose={() => setShowQuickAddSupplier(false)}
        onSuccess={(supplier) => {
          // Set the newly created supplier as selected
          form.setFieldsValue({
            supplierId: supplier.id,
          });
          if (setSelectedSupplierId) {
            setSelectedSupplierId(supplier.id);
          }
          // Refetch suppliers to ensure the new one appears in the list
          refetchSuppliers();
          setShowQuickAddSupplier(false);
        }}
      />
    </div>
  );
};

export default SupplierOrderInfor;
